<app-page>
  <div class="col-12 md:col-9 xl:col-6 m-auto py-4 px-4 text-sm md:text-base">
    <app-custom-toast toastTitle="Your payment information has been successfully updated."
      toastStyle="text-emerald-900 bg-emerald-100 border-emerald-200 font-normal"
      toastIconStyle="pi pi-check-circle text-emerald-900"
      [showToast]="showToast"></app-custom-toast>
    <app-custom-toast [toastmessage]="updateBillingInfoErrorMessage?.message || ''"
      toastStyle="text-rose-900 bg-rose-100 border-rose-200 font-normal"
      toastIconStyle="pi pi-exclamation-triangle text-rose-900" 
      [toastLink]="updateBillingInfoErrorMessage?.link || ''"
      [toastLinkText]="updateBillingInfoErrorMessage?.linkText || ''" 
      [buttonName]="updateBillingInfoPhone" [location]= "updateBillingInfoPageLocation"
      [showToast]="showUpdateBillingInfoErrorToast && !!updateBillingInfoErrorMessage">
    </app-custom-toast>
  <p-card header="Update billing" styleClass="bg-slate-100 mt-2">
    <p [innerHTML]="updateBillingDescription"></p>
    <p-tabs [(value)]="value" (valueChange)="updatePaymentType($event)" class="border-round-lg shadow-2 mt-4">
      <p-tablist>
        <p-tab [value]="0" data-auto-id="bank-account-tab">
          <i class="pi pi-building-columns mr-2"></i>
          <span>Bank account</span>
        </p-tab>
        <p-tab [value]="1" data-auto-id="credit-card-tab">
          <i class="pi pi-credit-card mr-2"></i>
          <span>Credit card</span>
        </p-tab>
      </p-tablist>

      <p-tabpanels>
        <p-tabpanel [value]="0">
          <app-bank-account-info ></app-bank-account-info>
        </p-tabpanel>

        <p-tabpanel [value]="1">
          <app-credit-card-info ></app-credit-card-info>
        </p-tabpanel>
        <div class="w-full pt-4 pb-2">
          <app-billing-address-info ></app-billing-address-info>
        </div>
        <div class="w-full pt-2">
          <p-divider></p-divider>
          <div class="text-xs text-slate-500">
            <p *ngIf="contractData?.balanceInfo?.paymentScheduleTypeCode === 'MONTHLY'" data-auto-id="monthly-list-value">
              Your {{paymentType}} will be saved for future re-occurring payments. Billing will continue on {{billingDay}} of each month for {{contractData?.baseContract?.chrgAmt | currency:'USD':'symbol-narrow'}}/month (subject to applicable discounts).
            </p>
            <p *ngIf="contractData?.balanceInfo?.paymentScheduleTypeCode === 'ANNUAL'" data-auto-id="annual-list-value">
              Your {{paymentType}} will be securely saved for future re-occurring payments. A reminder notice will be sent to you at least 45 days prior to your renewal date and recurring payment.
            </p>
            <p>{{ lockSymbol }} {{ secureEncryptionMessage }}</p>
          </div>
          <div class="flex align-items-center mt-4">
            <p-checkbox [(ngModel)]="tncCheck" binary="true" inputId="tncCheckbox" data-auto-id="tnc-checkbox">
            </p-checkbox>
            <label for="tncCheckbox" class="ml-2 text-sm flex flex-wrap align-items-center cursor-pointer">
              <span>I agree to&nbsp;</span>
              <span class="text-blue-700 font-semibold" tabindex="0" role="button" (keydown.enter)="showTnC = true" (keydown.space)="showTnC = true" (click)="showTnC = true" data-auto-id="tnc-button">
                terms and conditions
              </span>
            </label>
          </div>
          <div class="flex flex-column mt-4">
            <p-button [disabled]="disableSaveButton() || isSubmitting" [rounded]="true" data-auto-id="save-button"
              class="flex align-items-center justify-content-center w-full" styleClass="w-full" (click)="submitForm()" >
              <ng-container *ngIf="isSubmitting">
                <i class="pi pi-spin pi-spinner"></i>&nbsp;Saving information
              </ng-container>
              <ng-container *ngIf="!isSubmitting"> Save </ng-container>
            </p-button>
            <br>
            <p-button label="Back" [rounded]="true" severity="secondary" variant="outlined" data-auto-id="back-button"
                class="flex align-items-center justify-content-center w-full"
              styleClass="w-full shadow-button" (click)="navigateBack()" />
          </div>
        </div>
      </p-tabpanels>
    </p-tabs>
  </p-card>
</div>
</app-page>

<p-dialog [(visible)]="showTnC" modal class="text-sm md:text-base" [closable]="false" styleClass="p-0 m-0 lg:w-9 w-8" [contentStyle]="{ 'padding': '0px' }">
  <ng-template pTemplate="header">
    <div class="flex align-items-center justify-content-center relative w-full">
      <span class="custom-bold">Terms & Conditions</span>
      <p-button
        icon="pi pi-times"
        severity="secondary"
        class="absolute right-0 text-sm"
        styleClass="bg-white text-sm"
        [rounded]="true"
        (click)="showTnC = false"
        data-auto-id="close-button"
        >
      </p-button>
    </div>
  </ng-template>
  <p-divider></p-divider>
  <p class="px-4">{{value === 1 ? terms['PAYMENTECH'] : terms['ACH-AUTO']}}</p>
  <p-divider></p-divider>
  <div class="flex px-3 pb-3">
    <p-button [rounded]="true" label="Done" severity="primary" class="w-full" styleClass="w-full" (click)="showTnC = false" data-auto-id="done-button" />
  </div>

</p-dialog>
